// 全局变量
const NA = navigator.userAgent;
/*
      * @param: obj - 对象
      * @return: Object{
		  sortObj[key值按照字母排序的对象]
		  sortObjStr[把排序好的对象用字符串连起来]
	  }
  */
const getObjKeySort = function (obj) {
  if (Object.prototype.toString.call(obj).slice(8, -1) !== "Object") {
    // throw new Error('参数必须是一个对象');
    return;
  }
  var newkey = Object.keys(obj).sort();
  var objStrArr = [];
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    if (Object.prototype.toString.call(obj[newkey[i]]) == "[object Array]") {
      newObj[newkey[i]] = JSON.stringify(obj[newkey[i]]);
      obj[newkey[i]] != null &&
        objStrArr.push(`${newkey[i]}=${JSON.stringify(obj[newkey[i]])}&`);
    } else if (
      Object.prototype.toString.call(obj[newkey[i]]) == "[object object]"
    ) {
      newObj[newkey[i]] = JSON.stringify(obj[newkey[i]]);
      obj[newkey[i]] != null &&
        objStrArr.push(`${newkey[i]}=${JSON.stringify(obj[newkey[i]])}&`);
    } else {
      newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
      obj[newkey[i]] != null &&
        objStrArr.push(`${newkey[i]}=${obj[newkey[i]]}&`);
    }
  }

  return {
    sortObj: newObj, //返回排好序的新对象
    sortObjStr: objStrArr.join(""),
  };
};

/**
 * 日期格式化
 * @param date
 * @param format YYYY年MM月dd日hh时mm分ss秒
 * @returns {string}
 */
const dateToyyyymmdd = function (date, format) {
  var time = "";
  try {
    var d = new Date(date);
    var YYYY = d.getFullYear();
    var M = d.getMonth() + 1;
    var D = d.getDate();
    var h = d.getHours();
    var m = d.getMinutes();
    var s = d.getSeconds();

    time = format.replace("YYYY", YYYY);
    var MM = M < 10 ? "0" + M : M;
    time = time.replace("MM", MM);
    var DD = D < 10 ? "0" + D : D;
    time = time.replace("dd", DD);
    var hh = h < 10 ? "0" + h : h;
    time = time.replace("hh", hh);
    var mm = m < 10 ? "0" + m : m;
    time = time.replace("mm", mm);
    var ss = s < 10 ? "0" + s : s;
    time = time.replace("ss", ss);
  } catch (err) {
    console.log(err);
  }
  return time;
};

const formatSeconds = function (a) {
  // 将秒数格式化
  var length = "";
  var hh = parseInt(a / 3600);
  if (hh < 10) hh = "0" + hh;
  var mm = parseInt((a - hh * 3600) / 60);
  if (mm < 10) mm = "0" + mm;
  var ss = parseInt((a - hh * 3600) % 60);
  if (ss < 10) ss = "0" + ss;

  if (hh > 0) {
    length += hh + ":";
  }
  if (mm > 0) {
    length += mm + ":" + ss;
  } else {
    length += "0:" + ss;
  }

  if (a > 0) {
    return length;
  }
};

// 判断是否为ios
export const isIos = /iPhone|iPod|iPad|Macintosh|Mac/i.test(NA);
// 判断是否为Android
export const isAndroid = /Android/i.test(NA) || /Adr/i.test(NA);
// 是否为鸿蒙
export const isHarmony = /OpenHarmony|HUAWEI/i.test(NA.toLowerCase());
// 判断是否在埋堆堆客户端内
export const isMdd = /mddios|mddandroid|mddharmony/i.test(NA.toLowerCase());
// 判断是否在微信
export const isWeChat = /MicroMessenger/.test(NA);

export const isPC = () => {
  const Agents = [
    "android",
    "iphone",
    "symbianos",
    "windows phone",
    "ipad",
    "ipod",
    "mobile",
  ];
  return !Agents.some((item) => NA.toLowerCase().indexOf(item) > -1);
};

export const judgeIsHttp = (url) => {
  if (!url || typeof url !== "string") return false;
  return (
    url.substr(0, 7).toLowerCase() === "http://" ||
    url.substr(0, 8).toLowerCase() === "https://"
  );
};

//版本号对比方
export const diffVersion = function (refer_version, cur_version) {
  if (!refer_version || !cur_version) return false;
  let flag = false;
  let c_arr = cur_version.split(".");
  let r_arr = refer_version.split(".");
  for (let index = 0; index < r_arr.length; index++) {
    if (c_arr[index] > r_arr[index]) {
      flag = true;
      break;
    } else if (c_arr[index] == r_arr[index]) {
      flag = true;
      continue;
    } else {
      flag = false;
      break;
    }
  }
  return flag;
};
//获取数据的类型
export const typeOf = function (obj) {
  let str = Object.prototype.toString.call(obj);
  str = str.replace(/\[|\]/g, "").split(" ")[1];
  return str.toLowerCase();
};

/**
 * @description 设置cookie
 * @param cname [String] cookie key
 *        cvalue: [String] cookie value
 *        exTime: 过期时间 单位毫秒(即exTime毫秒后过期)
 */
export const setCookie = function (cname, cvalue, exTime, path = "/") {
  var d = new Date();
  d.setTime(d.getTime() + exTime);
  var expires = "expires=" + d.toGMTString();
  var _path = `path=${path}`;
  document.cookie = `${cname}=${cvalue};${_path};${expires}`;
};

/**
 * @description 获取cookie
 * @param cname [String] cookie key
 */
export const getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const isEmptyValue = (val) => {
  // null or undefined
  if (val == null) return true;

  if (typeof val === "boolean") return false;

  if (typeof val === "number") return !val && val !== 0;

  if (val instanceof Error) return val.message === "";

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case "[object String]":
    case "[object Array]":
      return !val.length;

    // Map or Set or File
    case "[object File]":
    case "[object Map]":
    case "[object Set]": {
      return !val.size;
    }
    // Plain Object
    case "[object Object]": {
      return !Object.keys(val).length;
    }
  }

  return false;
};

export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};

export const handleHttp = (url) => {
  if (url.startsWith("http://")) {
    url = url.replace("http:", "");
  }
  return url;
};

export const changeToHttps = (url) => {
  if (url.startsWith("http://")) {
    url = url.replace("http:", "https:");
  }
  return url;
};

export const throttle = (fn, threshhold) => {
  let last;
  let timer;
  threshhold || (threshhold = 250);
  return function () {
    let context = this,
      args = arguments;
    let now = +new Date();
    if (last && now < last + threshhold) {
      // 如果在时间阈值内，则清除上一次的计时器并设置新的
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      // 如果超过了时间阈值，直接执行函数
      last = now;
      fn.apply(context, args);
    }
  };
};

export { getObjKeySort, dateToyyyymmdd, formatSeconds };
